import script from "./chatMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./chatMessage.vue?vue&type=script&setup=true&lang=js"

import "./chatMessage.vue?vue&type=style&index=0&id=ad8f5bbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad8f5bbc"]])

export default __exports__